'use client';

import { css } from '@repo/pandacss/styled-system/css';
import Image from 'next/image';
import { useState } from 'react';

function CloseIcon() {
  return (
    <svg
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={css({
        fontSize: 'xl',
        color: 'neutral.dark',
        height: '[1em]',
        width: '[1em]',
      })}
    >
      <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
    </svg>
  );
}

export function ErrorPopup() {
  const [open, setOpen] = useState(true);

  if (!open) return null;

  return (
    <div
      role="presentation"
      className={css({
        alignItems: 'center',
        display: 'flex',
        position: 'fixed',
        top: { base: '2', sm: '6' },
        left: { base: '2', sm: '[50%]' },
        right: { base: '2', sm: '[auto]' },
        transform: { sm: 'translateX(-50%)' },
        zIndex: '[1400]',
        paddingLeft: '2',
        paddingRight: '2',
        paddingTop: { base: '4', sm: '3', md: '1' },
      })}
    >
      <div
        className={css({
          display: 'flex',
          alignItems: 'center',
          bgColor: 'neutral.white',
          borderTopLeftRadius: 'sm',
          borderTopRightRadius: 'sm',
          borderBottomRightRadius: 'sm',
          borderBottomLeftRadius: 'sm',
          boxShadow: '[0px 1px 3px 0px #0000004D]',
          paddingLeft: '5',
          paddingRight: '2',
          paddingBlockStart: { base: '2', sm: '3' },
          paddingBlockEnd: { base: '2', sm: '3' },
          borderLeftWidth: 'thick',
          borderLeftStyle: 'solid',
          borderTopColor: 'red.main',
          borderRightColor: 'red.main',
          borderBottomColor: 'red.main',
          borderLeftColor: 'red.main',
          width: { base: '[calc(100vw - 40px)]', sm: 'auto' },
          maxWidth: { base: '[calc(100vw - 40px)]', sm: '[600px]' },
          transitionProperty: '[opacity]',
          transitionDuration: '[225ms]',
          transitionTimingFunction:
            '[cubic-bezier(0.4, 0, 0.2, 1), transform 150ms cubic-bezier(0.4, 0, 0.2, 1)]',
        })}
      >
        <div
          className={css({
            display: 'flex',
            alignSelf: 'flex-start',
          })}
        >
          <Image
            width={24}
            height={24}
            src="https://www.nerdwallet.com/cdn-cgi/image/format=auto,quality=80,fit=contain,width=24,height=24,sharpen=1/cdn/banking/icons/alert-red.svg"
            alt="Error Alert"
            unoptimized
          />
        </div>
        <div
          className={css({
            display: 'flex',
            whiteSpace: { base: 'normal', sm: 'nowrap' },
            paddingLeft: '2',
          })}
        >
          <span
            className={css({
              lineHeight: 'normal',
              textStyle: 'textSmall',
            })}
          >
            Something went wrong. Please refresh the page.
          </span>
        </div>
        <button
          onClick={() => {
            setOpen(false);
            window.location.reload();
          }}
          className={css({
            marginLeft: '1',
            alignSelf: 'center',
            paddingInlineStart: '3',
            paddingInlineEnd: '3',
            paddingBlockStart: '0',
            paddingBlockEnd: '0',
            borderTopStyle: 'none',
            borderRightStyle: 'none',
            borderBottomStyle: 'none',
            borderLeftStyle: 'none',
            backgroundImage: '[none]',
            cursor: 'pointer',
          })}
        >
          <span
            className={css({
              color: 'red.dark',
              lineHeight: 'normal',
              textStyle: 'textSmallBold',
            })}
          >
            Refresh
          </span>
        </button>
        <button
          onClick={() => setOpen(false)}
          className={css({
            paddingInlineStart: '1',
            paddingInlineEnd: '1',
            borderTopStyle: 'none',
            borderRightStyle: 'none',
            borderBottomStyle: 'none',
            borderLeftStyle: 'none',
            backgroundImage: '[none]',
            cursor: 'pointer',
          })}
        >
          <CloseIcon />
        </button>
      </div>
    </div>
  );
}
